const createContainer = () => {
    const portalId = 'notifications'

    const modalContainer = document.getElementById(portalId)
    if (modalContainer) return modalContainer

    const element = document.createElement('div')
    element.setAttribute('id', portalId)
    element.classList.add('notify-container')
    document.body.appendChild(element)
    return element
}

export default createContainer
